// src/components/canine-teeth/ToolCanineTeeth.js

import React, { useEffect, useState } from 'react';
import ImageUpload from './ImageUpload';
import Topbar from '../Topbar';
import { auth, db } from '../../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import '../tools.css';
import { useNavigate } from 'react-router-dom';
import { Circles } from 'react-loader-spinner';

const ToolCanineTeeth = () => {
  const [user, setUser] = useState(null);
  const [userInfo, setUserInfo] = useState(null);
  const [isAuthLoading, setIsAuthLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setUser(user);
        const docRef = doc(db, 'users', user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setUserInfo(docSnap.data());
        }
      } else {
        setUser(null);
        navigate('/');
      }
      setIsAuthLoading(false); // Imposta isAuthLoading a false quando lo stato di autenticazione è determinato
    });

    return () => unsubscribe();
  }, [navigate]);

  if (isAuthLoading) {
    return (
        <div className="loading-overlay">
            <div className="loading-content">
                <Circles height="80" width="80" color="#ffffff" ariaLabel="loading" />
                <p>Loading... Syncing profile info</p>
            </div>
        </div>
    );
}

  return (
    <div className="tool-container">
      {user && userInfo && <Topbar userInfo={userInfo} user={user} />}
      <h2>Assessment of Pubertal Growth Spurt by Cervical Spine X-ray</h2>
      {user ? <ImageUpload /> : <div>Please log in to use this tool.</div>}
    </div>
  );
};

export default ToolCanineTeeth;
